import React from 'react';
import styled from 'styled-components';

const PStyle = styled.div`
  max-width: 650px;
  margin: 0 auto;
  font-size: 1.7rem;
  line-height: 1.9;
  font-weight: 300;
  color: var(--text-secondary);
  
  p {
    margin-bottom: 2rem;
  }
  
  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 1.8;
  }
`;

export default function PText({ children }) {
  return (
    <PStyle className="para">
      <p>{children}</p>
    </PStyle>
  );
}
